/**
 * O que faz: Query compartilhada de métricas com cache por identidade e contexto.
 * Onde usa: Dashboard e seções analíticas (comercial, follow-up, disparos, atendimento, operação).
 * Conexões: TanStack Query, metricasService, contextoMetricas.
 * Tabelas: Nenhuma direta; consome RPCs via buscarMetricas.
 * Data: 05/09/2026.
 */

import { useQuery } from '@tanstack/react-query';
import type { DominioMetricas } from '../../../supabase/functions/_shared/metricas/contratos';
import { buscarMetricas, erroRepetivel } from '../../services/metricasService';
import { chaveMetricas, type ContextoMetricas } from './contextoMetricas';

export function useMetricas(dominio: DominioMetricas, contexto: ContextoMetricas | undefined, habilitado = true) {
  // Loading/erro pertencem ao hook; o servidor nunca mistura número com estado assíncrono.
  const consulta = useQuery({
    queryKey: contexto ? chaveMetricas(dominio, contexto) : ['metricas-v1', 'sem-contexto', dominio],
    queryFn: ({ signal }) => buscarMetricas(dominio, contexto!, signal),
    enabled: habilitado && Boolean(contexto?.usuarioId && contexto?.clinicaId),
    staleTime: 60_000,
    gcTime: 600_000,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    retry: (tentativas, erro) => tentativas < 1 && erroRepetivel(erro),
  });
  return consulta;
}
